import { setupAccountReducer } from './setup-account';

export const brandReducer = setupAccountReducer;
